//@flow

// AppendixPage.js
// adapated from OverallStudyResultsPage.js

import * as React from 'react';
//import Modal from '../components/Modal.js';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';
import type { AppStateType, DataType } from '../Types';
import DetectionsTable from '../components/DetectionsTable.js';
import helpers from '../util/helpers';

type Props = {
  appState: AppStateType
}

class AppendixPage extends React.Component<Props> {

    mydetections_UNFILTERED():  DataType[] {
        //let wantwaterYN = this.waterpage();
        return this.props.appState.data
        .filter((d) => d.mine === true);
        //  .filter(this.mydetections_waterFilterFunction, wantwaterYN)
        //  .sort(this.mydetections_Compare)
    }

    render() {
        return (
            <div className="page appendix-page">
   
        <h1>
            <FormattedMessage id='your_results' defaultMessage='Your Results' />
        </h1>
        
        <h2 class="capfirstletter">
            <FormattedMessage id='in_urine' defaultMessage='XXX2' />
        </h2>

        <DetectionsTable
            thedetections={this.mydetections_UNFILTERED()}
            iswatertable={false}
            thispage={this}
        />

        <h2 class="capfirstletter">
            <FormattedMessage id='in_water' defaultMessage='XXX2' />
        </h2>

        <DetectionsTable
            thedetections={this.mydetections_UNFILTERED()}
            iswatertable={true}
            thispage={this}
        />

            </div>

        )
    }
} // end AppendixPage

export default injectIntl(observer(AppendixPage));



// WEBPACK FOOTER //
// ./src/pages/AppendixPage.js